export const actionTypes = {

  // Base
  INIT_USER: 'INIT_USER',
  GET_ADMIN_DATA: 'GET_ADMIN_DATA',
  GET_CUSTOMER_DATA: 'GET_CUSTOMER_DATA',
  LOGOUT_CUSTOMER: 'LOGOUT_CUSTOMER',
  LOGOUT_ADMIN: 'LOGOUT_ADMIN',
  CHANGE_CUSTOMER_DATA: 'CHANGE_CUSTOMER_DATA',
  CHANGE_ADMIN_DATA: 'CHANGE_ADMIN_DATA',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  SAVE_USER_DATA: 'SAVE_USER_DATA',
  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
  DISCONNECT_INSTAGRAM_ACCOUNT: 'DISCONNECT_INSTAGRAM_ACCOUNT',
  GET_MARKET_INSTAGRAM_MEDIA: 'GET_MARKET_INSTAGRAM_MEDIA',

  // Anonymous
  LOGIN_USER: 'LOGIN_USER',
  RESET_PASSWORD: 'RESET_PASSWORD',
  REGISTER_USER: 'REGISTER_USER',
  GET_RESET_PASSWORD_DATA: 'GET_RESET_PASSWORD_DATA',
  GET_CONFIRMATION_DATA: 'GET_CONFIRMATION_DATA',
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  CONFIRM_RESET_PASSWORD: 'CONFIRM_RESET_PASSWORD',
  GET_ANON_MARKET: 'GET_ANON_MARKET',
  CREATE_USER: 'CREATE_USER',
  CREATE_MARKET: 'CREATE_MARKET',
  SEND_FEEDBACK: 'SEND_FEEDBACK',
  GET_SHELF_TYPE_SERVICES_ANON: 'GET_SHELF_TYPE_SERVICES_ANON',
  GET_SHELF_TYPES_ANON: 'GET_SHELF_TYPES_ANON',
  GET_SHELF_PERIOD_PRICES_ANON: 'GET_SHELF_PERIOD_PRICES_ANON',
  GET_SHELF_TYPE_AVAILABILITY_ANON: 'GET_SHELF_TYPE_AVAILABILITY_ANON',
  BOOKING_REQUEST_RESERVE_ANON: 'BOOKING_REQUEST_RESERVE_ANON',
  BOOKING_REQUEST_INIT_PAYMENT_ANON: 'BOOKING_REQUEST_INIT_PAYMENT_ANON',
  BOOKING_REQUEST_CONFIRM_PAYMENT_ANON: 'BOOKING_REQUEST_CONFIRM_PAYMENT_ANON',
  BOOKING_REQUEST_DELETE_ANON: 'BOOKING_REQUEST_DELETE_ANON',
  BOOKING_PAYMENT_TRANSACTION_FAIL_ANON: 'BOOKING_PAYMENT_TRANSACTION_FAIL_ANON',
  BOOKING_PAYMENT_TRANSACTION_CANCEL_ANON: 'BOOKING_PAYMENT_TRANSACTION_CANCEL_ANON',
  GET_BOOKING_REQUEST_ANON: 'GET_BOOKING_REQUEST_ANON',

  // Admin
  GET_ADMIN_MARKET: 'GET_ADMIN_MARKET',
  UPDATE_MARKET_SETTINGS: 'UPDATE_MARKET_SETTINGS',
  UPDATE_MARKET_LOGO: 'UPDATE_MARKET_LOGO',
  DELETE_MARKET_LOGO: 'DELETE_MARKET_LOGO',
  CREATE_MARKET_IMAGE: 'CREATE_MARKET_IMAGE',
  DELETE_MARKET_IMAGE: 'DELETE_MARKET_IMAGE',
  GET_CUSTOMER_LIST: 'GET_CUSTOMER_LIST',
  GET_ALL_CUSTOMERS: 'GET_ALL_CUSTOMERS',
  GET_CUSTOMER: 'GET_CUSTOMER',
  ADD_CUSTOMER: 'ADD_CUSTOMER',
  EDIT_CUSTOMER: 'EDIT_CUSTOMER',
  DELETE_CUSTOMER: 'DELETE_CUSTOMER',
  SEND_EMAIL_CONFIRMATION: 'SEND_EMAIL_CONFIRMATION',
  VERIFY_CUSTOMER: 'VERIFY_CUSTOMER',
  RESET_CUSTOMER_PASSWORD: 'RESET_CUSTOMER_PASSWORD',
  GET_PAYMENTS_INFO: 'GET_PAYMENTS_INFO',
  GET_SAVED_PERIODS: 'GET_SAVED_PERIODS',
  GET_SHELF_LIST: 'GET_SHELF_LIST',
  ADD_SHELF: 'ADD_SHELF',
  EDIT_SHELF: 'EDIT_SHELF',
  DELETE_SHELF: 'DELETE_SHELF',
  UPDATE_MARKET_CLOSING_DAYS: 'UPDATE_MARKET_CLOSING_DAYS',
  GET_SHELF_PERIOD_PRICE_LIST: 'GET_SHELF_PERIOD_PRICE_LIST',
  UPDATE_SHELF_PERIOD_PRICE: 'UPDATE_SHELF_PERIOD_PRICE',
  GET_SHELF_TYPE_ADDITIONAL_SERVICE_LIST: 'GET_SHELF_TYPE_ADDITIONAL_SERVICE_LIST',
  UPDATE_SHELF_TYPE_ADDITIONAL_SERVICE: 'UPDATE_SHELF_TYPE_ADDITIONAL_SERVICE',
  GET_BOOKING_PERIOD_LIST: 'GET_BOOKING_PERIOD_LIST',
  ADD_BOOKING_PERIOD: 'ADD_BOOKING_PERIOD',
  EDIT_BOOKING_PERIOD: 'EDIT_BOOKING_PERIOD',
  DELETE_BOOKING_PERIOD: 'DELETE_BOOKING_PERIOD',
  GET_ADDITIONAL_SERVICE_LIST: 'GET_ADDITIONAL_SERVICE_LIST',
  ADD_ADDITIONAL_SERVICE: 'ADD_ADDITIONAL_SERVICE',
  EDIT_ADDITIONAL_SERVICE: 'EDIT_ADDITIONAL_SERVICE',
  DELETE_ADDITIONAL_SERVICE: 'DELETE_ADDITIONAL_SERVICE',
  GET_SHELF_TYPE_LIST: 'GET_SHELF_TYPE_LIST',
  ADD_SHELF_TYPE: 'ADD_SHELF_TYPE',
  EDIT_SHELF_TYPE: 'EDIT_SHELF_TYPE',
  DELETE_SHELF_TYPE: 'DELETE_SHELF_TYPE',
  GET_CUSTOMER_BOOKING_REQUESTS: 'GET_CUSTOMER_BOOKING_REQUESTS',
  CONFIRM_BOOKING_REQUEST: 'CONFIRM_BOOKING_REQUEST',
  REFUND_BOOKING_REQUEST: 'REFUND_BOOKING_REQUEST',
  UPDATE_BOOKING_REQUEST_MARKET_DATES: 'UPDATE_BOOKING_REQUEST_MARKET_DATES',
  RESEND_BOOKING_PAYMENT_REQUEST_EMAIL: 'RESEND_BOOKING_PAYMENT_REQUEST_EMAIL',
  GET_CAMPAIGN_LIST: 'GET_CAMPAIGN_LIST',
  ADD_CAMPAIGN: 'ADD_CAMPAIGN',
  EDIT_CAMPAIGN: 'EDIT_CAMPAIGN',
  DELETE_CAMPAIGN: 'DELETE_CAMPAIGN',
  GET_SHELF_BOOKING_LIST: 'GET_SHELF_BOOKING_LIST',
  ADD_SHELF_BOOKING: 'ADD_SHELF_BOOKING',
  EDIT_SHELF_BOOKING: 'EDIT_SHELF_BOOKING',
  DELETE_SHELF_BOOKING: 'DELETE_SHELF_BOOKING',
  GET_CUSTOMER_BOOKINGS: 'GET_CUSTOMER_BOOKINGS',
  GET_CUSTOMER_PRODUCT_SHEETS: 'GET_CUSTOMER_PRODUCT_SHEETS',
  GET_CUSTOMER_PRODUCT_SHEET: 'GET_CUSTOMER_PRODUCT_SHEET',
  CREATE_CUSTOMER_PRODUCT_SHEET: 'CREATE_CUSTOMER_PRODUCT_SHEET',
  UPDATE_CUSTOMER_PRODUCT_SHEET: 'UPDATE_CUSTOMER_PRODUCT_SHEET',
  UPDATE_CUSTOMER_PRODUCT: 'UPDATE_CUSTOMER_PRODUCT',
  GET_CUSTOMER_BALANCE_TRANSACTIONS: 'GET_CUSTOMER_BALANCE_TRANSACTIONS',
  CREATE_CUSTOMER_BALANCE_TRANSACTION: 'CREATE_CUSTOMER_BALANCE_TRANSACTION',
  UPDATE_CUSTOMER_BALANCE_TRANSACTION: 'UPDATE_CUSTOMER_BALANCE_TRANSACTION',
  DELETE_CUSTOMER_BALANCE_TRANSACTION: 'DELETE_CUSTOMER_BALANCE_TRANSACTION',
  COMPLETE_CUSTOMER_PRODUCT_SHEET: 'COMPLETE_CUSTOMER_PRODUCT_SHEET',
  DELETE_CUSTOMER_PRODUCT_SHEET: 'DELETE_CUSTOMER_PRODUCT_SHEET',
  CREATE_CUSTOMER_SUBACCOUNT: 'CREATE_CUSTOMER_SUBACCOUNT',
  GET_CUSTOMER_PRODUCT_SALE_LINE_LIST: 'GET_CUSTOMER_PRODUCT_SALE_LINE_LIST',
  GET_CUSTOMER_PRODUCT_LIST: 'GET_CUSTOMER_PRODUCT_LIST',
  CREATE_CUSTOMER_PRODUCTS: 'CREATE_CUSTOMER_PRODUCTS',
  PRINT_CUSTOMER_PRODUCT_SHEET: 'PRINT_CUSTOMER_PRODUCT_SHEET',
  ADD_PRODUCTS_TO_CAMPAIGN: 'ADD_PRODUCTS_TO_CAMPAIGN',
  REMOVE_PRODUCTS_FROM_CAMPAIGN: 'REMOVE_PRODUCTS_FROM_CAMPAIGN',
  SAVE_PAYMENTS_DATES: 'SAVE_PAYMENTS_DATES',
  DELETE_SAVED_PERIOD: 'DELETE_SAVED_PERIOD',
  EXPORT_SALES_PERIOD_TO_ECONOMIC: 'EXPORT_SALES_PERIOD_TO_ECONOMIC',
  SEND_PAYMENT_TO_CUSTOMERS: 'SEND_PAYMENT_TO_CUSTOMERS',
  FINALIZE_SALES_PERIOD: 'FINALIZE_SALES_PERIOD',
  RESET_SALES_PERIOD: 'RESET_SALES_PERIOD',
  EXPORT_CUSTOMER_PRODUCT_SALES_REPORT: 'EXPORT_CUSTOMER_PRODUCT_SALES_REPORT',
  GET_CUSTOMER_PRODUCT_SALES: 'GET_CUSTOMER_PRODUCT_SALES',
  GET_BOOKING_TRANSACTION_REPORT: 'GET_BOOKING_TRANSACTION_REPORT',
  EXPORT_BOOKING_TRANSACTION_REPORT: 'EXPORT_BOOKING_TRANSACTION_REPORT',
  GET_CUSTOMER_PAYMENT_REPORTS: 'GET_CUSTOMER_PAYMENT_REPORTS',
  SEND_PAYMENT_REPORT_TO_CUSTOMER: 'SEND_PAYMENT_REPORT_TO_CUSTOMER',
  DOWNLOAD_CUSTOMER_PAYMENT_REPORT_PDF: 'DOWNLOAD_CUSTOMER_PAYMENT_REPORT_PDF',
  GET_FINALIZED_SAVED_PERIODS: 'GET_FINALIZED_SAVED_PERIODS',
  DOWNLOAD_TOTAL_PAYMENT_REPORT_PDF: 'DOWNLOAD_TOTAL_PAYMENT_REPORT_PDF',
  GET_BANK_EXPORT_TRANSACTIONS: 'GET_BANK_EXPORT_TRANSACTIONS',
  EDIT_BANK_EXPORT_TRANSACTION: 'EDIT_BANK_EXPORT_TRANSACTION',
  DELETE_BANK_EXPORT_TRANSACTION: 'DELETE_BANK_EXPORT_TRANSACTION',
  GET_ECONOMIC_LAYOUTS: 'GET_ECONOMIC_LAYOUTS',
  GET_MARKET_MESSAGES: 'GET_MARKET_MESSAGES',
  DELETE_MARKET_MESSAGE: 'DELETE_MARKET_MESSAGE',
  DELETE_MARKET_MESSAGES: 'DELETE_MARKET_MESSAGES',
  GET_BOOKINGS_REPORT: 'GET_BOOKINGS_REPORT',
  UPDATE_MARKET_MESSAGES: 'UPDATE_MARKET_MESSAGES',
  UPDATE_MARKET_MESSAGE: 'UPDATE_MARKET_MESSAGE',
  ADD_USER_PRODUCT_TO_CAMPAIGN: 'ADD_USER_PRODUCT_TO_CAMPAIGN',
  REMOVE_USER_PRODUCT_FROM_CAMPAIGN: 'REMOVE_USER_PRODUCT_FROM_CAMPAIGN',
  GET_CUSTOMER_CAMPAIGN_REPORT: 'GET_CUSTOMER_CAMPAIGN_REPORT',
  GET_CUSTOMER_BALANCE_REPORT: 'GET_CUSTOMER_BALANCE_REPORT',
  EXPORT_CUSTOMER_BALANCE_REPORT_PDF: 'EXPORT_CUSTOMER_BALANCE_REPORT_PDF',
  EXPORT_CUSTOMER_BALANCE_REPORT_XLSX: 'EXPORT_CUSTOMER_BALANCE_REPORT_XLSX',
  GET_MANUAL_TRANSACTIONS_REPORT: 'GET_MANUAL_TRANSACTIONS_REPORT',
  EXPORT_MANUAL_TRANSACTIONS_REPORT_PDF: 'EXPORT_MANUAL_TRANSACTIONS_REPORT_PDF',
  EXPORT_MANUAL_TRANSACTIONS_REPORT_XLSX: 'EXPORT_MANUAL_TRANSACTIONS_REPORT_XLSX',
  DOWNLOAD_CASH_PAYOUT_SLIP: 'DOWNLOAD_CASH_PAYOUT_SLIP',

  // User
  GET_USER_MARKET: 'GET_USER_MARKET',
  GET_SALE_LINES_LIST: 'GET_SALE_LINES_LIST',
  GET_SALE_LINES_SUMMARY: 'GET_SALE_LINES_SUMMARY',
  SEND_FEEDBACK_TO_MARKET: 'SEND_FEEDBACK_TO_MARKET',
  GET_PRODUCT_SALE_LINE_LIST: 'GET_PRODUCT_SALE_LINE_LIST',
  GET_USER_PRODUCT_SHEET_LIST: 'GET_USER_PRODUCT_SHEET_LIST',
  GET_USER_PRODUCT_SHEET: 'GET_USER_PRODUCT_SHEET',
  CREATE_USER_PRODUCT_SHEET: 'CREATE_USER_PRODUCT_SHEET',
  UPDATE_USER_PRODUCT_SHEET: 'UPDATE_USER_PRODUCT_SHEET',
  COMPLETE_USER_PRODUCT_SHEET: 'COMPLETE_USER_PRODUCT_SHEET',
  PRINT_USER_PRODUCT_SHEET: 'PRINT_USER_PRODUCT_SHEET',
  DELETE_USER_PRODUCT_SHEET: 'DELETE_USER_PRODUCT_SHEET',
  GET_USER_PRODUCT_LIST: 'GET_USER_PRODUCT_LIST',
  CHECKOUT_CUSTOMER_PRODUCT: 'CHECKOUT_CUSTOMER_PRODUCT',
  REVERT_CUSTOMER_PRODUCT_CHECKOUT: 'REVERT_CUSTOMER_PRODUCT_CHECKOUT',
  CREATE_USER_PRODUCTS: 'CREATE_USER_PRODUCTS',
  REQUEST_PRODUCT_CAMPAIGN: 'REQUEST_PRODUCT_CAMPAIGN',
  REQUEST_PRODUCT_CAMPAIGN_REMOVAL: 'REQUEST_PRODUCT_CAMPAIGN_REMOVAL',
  GET_PAYMENT_REPORTS: 'GET_PAYMENT_REPORTS',
  DOWNLOAD_PAYMENT_REPORT_PDF: 'DOWNLOAD_PAYMENT_REPORT_PDF',
  GET_ALL_CUSTOMER_BOOKINGS: 'GET_ALL_CUSTOMER_BOOKINGS',
  GET_SHELF_TYPES: 'GET_SHELF_TYPES',
  GET_SHELF_TYPE_SERVICES: 'GET_SHELF_TYPE_SERVICES',
  GET_SHELF_PERIOD_PRICES: 'GET_SHELF_PERIOD_PRICES',
  GET_SHELF_TYPE_AVAILABILITY: 'GET_SHELF_TYPE_AVAILABILITY',
  GET_BOOKING_REQUEST: 'GET_BOOKING_REQUEST',
  BOOKING_REQUEST_RESERVE: 'BOOKING_REQUEST_RESERVE',
  BOOKING_REQUEST_INIT_PAYMENT: 'BOOKING_REQUEST_INIT_PAYMENT',
  BOOKING_REQUEST_CONFIRM_PAYMENT: 'BOOKING_REQUEST_CONFIRM_PAYMENT',
  BOOKING_REQUEST_DELETE: 'BOOKING_REQUEST_DELETE',
  BOOKING_PAYMENT_TRANSACTION_FAIL: 'BOOKING_PAYMENT_TRANSACTION_FAIL',
  BOOKING_PAYMENT_TRANSACTION_CANCEL: 'BOOKING_PAYMENT_TRANSACTION_CANCEL',
  SWITCH_CUSTOMER_ACCOUNT: 'SWITCH_CUSTOMER_ACCOUNT',
  GET_CUSTOMER_ACCOUNTS: 'GET_CUSTOMER_ACCOUNTS',
}

export const mutationTypes = {
  // Base
  SET_LOADER: 'SET_LOADER',
  SET_MARKET_HEADER: 'SET_MARKET_HEADER',
  SET_TOKEN: 'SET_TOKEN',
  SET_AUTH: 'SET_AUTH',
  SET_USER: 'SET_USER',
  SET_USER_DATA: 'SET_USER_DATA',
  SET_CUSTOMER_DATA: 'SET_CUSTOMER_DATA',
  LOGOUT_CUSTOMER: 'LOGOUT_CUSTOMER',
  LOGOUT_ADMIN: 'LOGOUT_ADMIN',
  SET_MARKET_INSTAGRAM_MEDIA: 'SET_MARKET_INSTAGRAM_MEDIA',

  // Anonymous
  SET_RESET_PASSWORD_DATA: 'SET_RESET_PASSWORD_DATA',
  SET_CONFIRMATION_DATA: 'SET_CONFIRMATION_DATA',
  SET_ANON_MARKET: 'SET_ANON_MARKET',
  SET_SHELF_TYPE_AVAILABILITY_ANON: 'SET_SHELF_TYPE_AVAILABILITY_ANON',
  SET_SHELF_PERIOD_PRICES_ANON: 'SET_SHELF_PERIOD_PRICES_ANON',
  SET_SHELF_TYPES_ANON: 'SET_SHELF_TYPES_ANON',
  SET_SHELF_TYPE_SERVICES_ANON: 'SET_SHELF_TYPE_SERVICES_ANON',
  SET_BOOKING_REQUEST_ANON: 'SET_BOOKING_REQUEST_ANON',

  // Admin
  SET_ADMIN_MARKET: 'SET_ADMIN_MARKET',
  SET_MARKET_SETTINGS: 'SET_MARKET_SETTINGS',
  UPDATE_MARKET_LOGO: 'UPDATE_MARKET_LOGO',
  DELETE_MARKET_LOGO: 'DELETE_MARKET_LOGO',
  APPEND_MARKET_IMAGE: 'APPEND_MARKET_IMAGE',
  DELETE_MARKET_IMAGE: 'DELETE_MARKET_IMAGE',
  SET_CUSTOMER_LIST: 'SET_CUSTOMER_LIST',
  SET_ALL_CUSTOMERS: 'SET_ALL_CUSTOMERS',
  SET_CUSTOMER: 'SET_CUSTOMER',
  SET_CUSTOMER_PAGE: 'SET_CUSTOMER_PAGE',
  SET_CUSTOMER_FILTERS: 'SET_CUSTOMER_FILTERS',
  SET_CUSTOMER_PAGES_COUNT: 'SET_CUSTOMER_PAGES_COUNT',
  APPEND_CUSTOMER: 'APPEND_CUSTOMER',
  DELETE_CUSTOMER: 'DELETE_CUSTOMER',
  UPDATE_CUSTOMER: 'UPDATE_CUSTOMER',
  UPDATE_CUSTOMER_SUBACCOUNT: 'UPDATE_CUSTOMER_SUBACCOUNT',
  VERIFY_CUSTOMER: 'VERIFY_CUSTOMER',
  SET_PAYMENTS_INFO: 'SET_PAYMENTS_INFO',
  SET_SAVED_PERIODS: 'SET_SAVED_PERIODS',
  DELETE_SAVED_PERIOD: 'DELETE_SAVED_PERIOD',
  UPDATE_SALES_PERIOD: 'UPDATE_SALES_PERIOD',
  SET_CUSTOMER_PAYMENT_REPORTS: 'SET_CUSTOMER_PAYMENT_REPORTS',
  SET_CUSTOMER_PAYMENT_REPORTS_FILTERS: 'SET_CUSTOMER_PAYMENT_REPORTS_FILTERS',
  SET_CUSTOMER_PAYMENT_REPORTS_PAGE: 'SET_CUSTOMER_PAYMENT_REPORTS_PAGE',
  SET_CUSTOMER_PAYMENT_REPORTS_PAGES_COUNT: 'SET_CUSTOMER_PAYMENT_REPORTS_PAGES_COUNT',
  SET_FINALIZED_SAVED_PERIODS: "SET_FINALIZED_SAVED_PERIODS",
  SET_SHELF_LIST: 'SET_SHELF_LIST',
  SET_SHELF_FILTERS: 'SET_SHELF_FILTERS',
  SET_SHELF_PAGE: 'SET_SHELF_PAGE',
  SET_SHELF_PAGES_COUNT: 'SET_SHELF_PAGES_COUNT',
  APPEND_SHELF: 'APPEND_SHELF',
  DELETE_SHELF: 'DELETE_SHELF',
  UPDATE_SHELF: 'UPDATE_SHELF',
  SET_MARKET_CLOSING_DAYS: 'SET_MARKET_CLOSING_DAYS',
  SET_SHELF_PERIOD_PRICE_LIST: 'SET_SHELF_PERIOD_PRICE_LIST',
  SET_SHELF_TYPE_ADDITIONAL_SERVICE_LIST: 'SET_SHELF_TYPE_ADDITIONAL_SERVICE_LIST',
  SET_BOOKING_PERIOD_LIST: 'SET_BOOKING_PERIOD_LIST',
  SET_BOOKING_PERIOD_FILTERS: 'SET_BOOKING_PERIOD_FILTERS',
  APPEND_BOOKING_PERIOD: 'APPEND_BOOKING_PERIOD',
  DELETE_BOOKING_PERIOD: 'DELETE_BOOKING_PERIOD',
  UPDATE_BOOKING_PERIOD: 'UPDATE_BOOKING_PERIOD',
  SET_ADDITIONAL_SERVICE_LIST: 'SET_ADDITIONAL_SERVICE_LIST',
  SET_ADDITIONAL_SERVICE_FILTERS: 'SET_ADDITIONAL_SERVICE_FILTERS',
  APPEND_ADDITIONAL_SERVICE: 'APPEND_ADDITIONAL_SERVICE',
  DELETE_ADDITIONAL_SERVICE: 'DELETE_ADDITIONAL_SERVICE',
  UPDATE_ADDITIONAL_SERVICE: 'UPDATE_ADDITIONAL_SERVICE',
  SET_SHELF_TYPE_LIST: 'SET_SHELF_TYPE_LIST',
  SET_SHELF_TYPE_FILTERS: 'SET_SHELF_TYPE_FILTERS',
  SET_SHELF_TYPE_PAGE: 'SET_SHELF_TYPE_PAGE',
  SET_SHELF_TYPE_PAGES_COUNT: 'SET_SHELF_TYPE_PAGES_COUNT',
  APPEND_SHELF_TYPE: 'APPEND_SHELF_TYPE',
  DELETE_SHELF_TYPE: 'DELETE_SHELF_TYPE',
  UPDATE_SHELF_TYPE: 'UPDATE_SHELF_TYPE',
  SET_CUSTOMER_BOOKING_REQUESTS: 'SET_CUSTOMER_BOOKING_REQUESTS',
  SET_CUSTOMER_BOOKING_REQUEST_FILTERS: 'SET_CUSTOMER_BOOKING_REQUEST_FILTERS',
  SET_CUSTOMER_BOOKING_REQUEST_PAGE: 'SET_CUSTOMER_BOOKING_REQUEST_PAGE',
  SET_CUSTOMER_BOOKING_REQUEST_PAGES_COUNT: 'SET_CUSTOMER_BOOKING_REQUEST_PAGES_COUNT',
  APPEND_CUSTOMER_SUBACCOUNT: 'APPEND_CUSTOMER_SUBACCOUNT',
  UPDATE_BOOKING_REQUEST: 'UPDATE_BOOKING_REQUEST',
  SET_CAMPAIGN_LIST: 'SET_CAMPAIGN_LIST',
  SET_CAMPAIGN_FILTERS: 'SET_CAMPAIGN_FILTERS',
  SET_CAMPAIGN_PAGE: 'SET_CAMPAIGN_PAGE',
  SET_CAMPAIGN_PAGES_COUNT: 'SET_CAMPAIGN_PAGES_COUNT',
  APPEND_CAMPAIGN: 'APPEND_CAMPAIGN',
  DELETE_CAMPAIGN: 'DELETE_CAMPAIGN',
  UPDATE_CAMPAIGN: 'UPDATE_CAMPAIGN',
  SET_SHELF_BOOKING_LIST: 'SET_SHELF_BOOKING_LIST',
  SET_SHELF_BOOKING_METADATA: 'SET_SHELF_BOOKING_METADATA',
  SET_SHELF_BOOKING_FILTERS: 'SET_SHELF_BOOKING_FILTERS',
  APPEND_SHELF_BOOKING: 'APPEND_SHELF_BOOKING',
  DELETE_SHELF_BOOKING: 'DELETE_SHELF_BOOKING',
  UPDATE_SHELF_BOOKING: 'UPDATE_SHELF_BOOKING',
  SET_CUSTOMER_BOOKINGS: 'SET_CUSTOMER_BOOKINGS',
  SET_CUSTOMER_BOOKING_PAGE: 'SET_CUSTOMER_BOOKING_PAGE',
  SET_CUSTOMER_BOOKING_PAGES_COUNT: 'SET_CUSTOMER_BOOKING_PAGES_COUNT',
  SET_CUSTOMER_BOOKING_FILTERS: 'SET_CUSTOMER_BOOKING_FILTERS',
  SET_CUSTOMER_PRODUCT_SHEETS: 'SET_CUSTOMER_PRODUCT_SHEETS',
  SET_CUSTOMER_PRODUCT_SHEET: 'SET_CUSTOMER_PRODUCT_SHEET',
  SET_CUSTOMER_PRODUCT_SHEETS_PAGE: 'SET_CUSTOMER_PRODUCT_SHEETS_PAGE',
  SET_CUSTOMER_PRODUCT_SHEETS_PAGES_COUNT: 'SET_CUSTOMER_PRODUCT_SHEETS_PAGES_COUNT',
  SET_CUSTOMER_PRODUCT_SHEETS_FILTERS: 'SET_CUSTOMER_PRODUCT_SHEETS_FILTERS',
  UPDATE_CUSTOMER_PRODUCT_SHEET: 'UPDATE_CUSTOMER_PRODUCT_SHEET',
  APPEND_CUSTOMER_PRODUCT_SHEET: 'APPEND_CUSTOMER_PRODUCT_SHEET',
  DELETE_CUSTOMER_PRODUCT_SHEET: 'DELETE_CUSTOMER_PRODUCT_SHEET',
  SET_CUSTOMER_PRODUCT_SALE_LINE_LIST: 'SET_CUSTOMER_PRODUCT_SALE_LINE_LIST',
  SET_CUSTOMER_PRODUCT_LIST: 'SET_CUSTOMER_PRODUCT_LIST',
  SET_CUSTOMER_PRODUCT_FILTERS: 'SET_CUSTOMER_PRODUCT_FILTERS',
  SET_CUSTOMER_PRODUCT_PAGE: 'SET_CUSTOMER_PRODUCT_PAGE',
  SET_CUSTOMER_PRODUCT_PAGES_COUNT: 'SET_CUSTOMER_PRODUCT_PAGES_COUNT',
  APPEND_CUSTOMER_BALANCE_TRANSACTION: 'APPEND_CUSTOMER_BALANCE_TRANSACTION',
  SET_CUSTOMER_BALANCE_TRANSACTIONS: 'SET_CUSTOMER_BALANCE_TRANSACTIONS',
  SET_CUSTOMER_BALANCE_TRANSACTION: 'SET_CUSTOMER_BALANCE_TRANSACTION',
  SET_CUSTOMER_BALANCE_TRANSACTIONS_FILTERS: 'SET_CUSTOMER_BALANCE_TRANSACTIONS_FILTERS',
  SET_CUSTOMER_BALANCE_TRANSACTIONS_PAGE: 'SET_CUSTOMER_BALANCE_TRANSACTIONS_PAGE',
  SET_CUSTOMER_BALANCE_TRANSACTIONS_PAGES_COUNT: 'SET_CUSTOMER_BALANCE_TRANSACTIONS_PAGES_COUNT',
  REMOVE_UPDATE_CUSTOMER_BALANCE_TRANSACTIONS: 'REMOVE_UPDATE_CUSTOMER_BALANCE_TRANSACTIONS',
  UPDATE_CUSTOMER_PRODUCT: 'UPDATE_CUSTOMER_PRODUCT',
  SET_SAVE_TYPE: 'SET_SAVE_TYPE',
  SET_BANK_EXPORT_TRANSACTIONS: 'SET_BANK_EXPORT_TRANSACTIONS',
  SET_BANK_EXPORT_TRANSACTIONS_FILTERS: 'SET_BANK_EXPORT_TRANSACTIONS_FILTERS',
  UPDATE_BANK_EXPORT_TRANSACTION: 'UPDATE_BANK_EXPORT_TRANSACTION',
  DELETE_BANK_EXPORT_TRANSACTION: 'DELETE_BANK_EXPORT_TRANSACTION',
  SET_ECONOMIC_LAYOUTS: 'SET_ECONOMIC_LAYOUTS',
  SET_MARKET_MESSAGES: 'SET_MARKET_MESSAGES',
  SET_MARKET_MESSAGES_PAGE: 'SET_MARKET_MESSAGES_PAGE',
  SET_MARKET_MESSAGES_PAGES_COUNT: 'SET_MARKET_MESSAGES_PAGES_COUNT',
  SET_MARKET_MESSAGES_FILTERS: 'SET_MARKET_MESSAGES_FILTERS',
  DELETE_MARKET_MESSAGE: 'DELETE_MARKET_MESSAGE',
  DELETE_MARKET_MESSAGES: 'DELETE_MARKET_MESSAGES',
  SET_ADMIN_NAV_ITEMS: 'SET_ADMIN_NAV_ITEMS',
  SET_UNSEEN_MESSAGES_NUMBER: 'SET_UNSEEN_MESSAGES_NUMBER',
  SET_PENDING_BOOKING_REQUESTS: 'SET_PENDING_BOOKING_REQUESTS',
  UPDATE_MARKET_MESSAGE: 'UPDATE_MARKET_MESSAGE',
  SET_BOOKINGS_REPORT: 'SET_BOOKINGS_REPORT',
  SET_BOOKINGS_REPORT_FILTERS: 'SET_BOOKINGS_REPORT_FILTERS',
  SET_CUSTOMER_CAMPAIGN_REPORT: 'SET_CUSTOMER_CAMPAIGN_REPORT',
  SET_CUSTOMER_CAMPAIGN_REPORT_FILTERS: 'SET_CUSTOMER_CAMPAIGN_REPORT_FILTERS',
  SET_CUSTOMER_CAMPAIGN_REPORT_PAGE: 'SET_CUSTOMER_CAMPAIGN_REPORT_PAGE',
  SET_CUSTOMER_CAMPAIGN_REPORT_PAGES_COUNT: 'SET_CUSTOMER_CAMPAIGN_REPORT_PAGES_COUNT',
  SET_CUSTOMER_PRODUCT_SALES: 'SET_CUSTOMER_PRODUCT_SALES',
  SET_CUSTOMER_PRODUCT_SALES_TOTALS: 'SET_CUSTOMER_PRODUCT_SALES_TOTALS',
  SET_CUSTOMER_PRODUCT_SALES_FILTERS: 'SET_CUSTOMER_PRODUCT_SALES_FILTERS',
  SET_CUSTOMER_PRODUCT_SALES_PAGE: 'SET_CUSTOMER_PRODUCT_SALES_PAGE',
  SET_CUSTOMER_PRODUCT_SALES_PAGES_COUNT: 'SET_CUSTOMER_PRODUCT_SALES_PAGES_COUNT',
  SET_CUSTOMER_BOOKING_TRANSACTIONS: 'SET_CUSTOMER_BOOKING_TRANSACTIONS',
  SET_CUSTOMER_BOOKING_TRANSACTIONS_TOTALS: 'SET_CUSTOMER_BOOKING_TRANSACTIONS_TOTALS',
  SET_CUSTOMER_BOOKING_TRANSACTIONS_FILTERS: 'SET_CUSTOMER_BOOKING_TRANSACTIONS_FILTERS',
  SET_CUSTOMER_BOOKING_TRANSACTIONS_PAGE: 'SET_CUSTOMER_BOOKING_TRANSACTIONS_PAGE',
  SET_CUSTOMER_BOOKING_TRANSACTIONS_PAGES_COUNT: 'SET_CUSTOMER_BOOKING_TRANSACTIONS_PAGES_COUNT',
  UPDATE_MARKET_MESSAGES: 'UPDATE_MARKET_MESSAGES',
  SET_CUSTOMER_BALANCE_REPORT_LIST: 'SET_CUSTOMER_BALANCE_REPORT_LIST',
  SET_CUSTOMER_BALANCE_REPORT_PAGE: 'SET_CUSTOMER_BALANCE_REPORT_PAGE',
  SET_CUSTOMER_BALANCE_REPORT_PAGES_COUNT: 'SET_CUSTOMER_BALANCE_REPORT_PAGES_COUNT',
  SET_CUSTOMER_BALANCE_REPORT_TOTAL_BALANCE: 'SET_CUSTOMER_BALANCE_REPORT_TOTAL_BALANCE',
  SET_CUSTOMER_BALANCE_REPORT_FILTERS: 'SET_CUSTOMER_BALANCE_REPORT_FILTERS',
  SET_MANUAL_TRANSACTIONS_REPORT: 'SET_MANUAL_TRANSACTIONS_REPORT',
  SET_MANUAL_TRANSACTIONS_REPORT_PAGE: 'SET_MANUAL_TRANSACTIONS_REPORT_PAGE',
  SET_MANUAL_TRANSACTIONS_REPORT_PAGES_COUNT: 'SET_MANUAL_TRANSACTIONS_REPORT_PAGES_COUNT',
  SET_MANUAL_TRANSACTIONS_REPORT_FILTERS: 'SET_MANUAL_TRANSACTIONS_REPORT_FILTERS',

  // User
  SET_USER_NAV_ITEMS: 'SET_USER_NAV_ITEMS',
  SET_USER_MARKET: 'SET_USER_MARKET',
  SET_SALE_LINES_LIST: 'SET_SALE_LINES_LIST',
  SET_SALE_LINES_SUMMARY: 'SET_SALE_LINES_SUMMARY',
  SET_PRODUCT_SALE_LINE_LIST: 'SET_PRODUCT_SALE_LINE_LIST',
  SET_PRODUCT_SHEET_LIST: 'SET_PRODUCT_SHEET_LIST',
  SET_PRODUCT_SHEET: 'SET_PRODUCT_SHEET',
  SET_PRODUCT_SHEET_FILTERS: 'SET_PRODUCT_SHEET_FILTERS',
  SET_PRODUCT_SHEET_PAGE: 'SET_PRODUCT_SHEET_PAGE',
  SET_PRODUCT_SHEET_PAGES_COUNT: 'SET_PRODUCT_SHEET_PAGES_COUNT',
  APPEND_PRODUCT_SHEET: 'APPEND_PRODUCT_SHEET',
  DELETE_PRODUCT_SHEET: 'DELETE_PRODUCT_SHEET',
  UPDATE_PRODUCT_SHEET: 'UPDATE_PRODUCT_SHEET',
  UPDATE_SELECTED_PRODUCT_SHEET: 'UPDATE_SELECTED_PRODUCT_SHEET',
  SET_PRODUCT_LIST: 'SET_PRODUCT_LIST',
  SET_PRODUCT_FILTERS: 'SET_PRODUCT_FILTERS',
  SET_PRODUCT_PAGE: 'SET_PRODUCT_PAGE',
  SET_PRODUCT_PAGES_COUNT: 'SET_PRODUCT_PAGES_COUNT',
  SET_CAMPAIGN_REQUEST: 'SET_CAMPAIGN_REQUEST',
  SET_PAYMENT_REPORTS: 'SET_PAYMENT_REPORTS',
  SET_PAYMENT_REPORTS_FILTERS: 'SET_PAYMENT_REPORTS_FILTERS',
  SET_PAYMENT_REPORTS_PAGE: 'SET_PAYMENT_REPORTS_PAGE',
  SET_PAYMENT_REPORTS_PAGES_COUNT: 'SET_PAYMENT_REPORTS_PAGES_COUNT',
  SET_BOOKING_REQUEST: 'SET_BOOKING_REQUEST',
  SET_BOOKINGS_LIST: 'SET_BOOKINGS_LIST',
  SET_BOOKINGS_FILTERS: 'SET_BOOKINGS_FILTERS',
  SET_BOOKINGS_PAGE: 'SET_BOOKINGS_PAGE',
  SET_BOOKINGS_PAGES_COUNT: 'SET_BOOKINGS_PAGES_COUNT',
  SET_SHELF_TYPE_SERVICES: 'SET_SHELF_TYPE_SERVICES',
  SET_SHELF_TYPES: 'SET_SHELF_TYPES',
  SET_SHELF_PERIOD_PRICES: 'SET_SHELF_PERIOD_PRICES',
  SET_SHELF_TYPE_AVAILABILITY: 'SET_SHELF_TYPE_AVAILABILITY',
  SET_CUSTOMER_ACCOUNTS: 'SET_CUSTOMER_ACCOUNTS',

  // User and admin
  SET_SALE_LINES_FILTERS: 'SET_SALE_LINES_FILTERS',
}
